import { render, staticRenderFns } from "./PageIns.vue?vue&type=template&id=a584f170&scoped=true&"
import script from "./PageIns.vue?vue&type=script&lang=js&"
export * from "./PageIns.vue?vue&type=script&lang=js&"
import style0 from "./PageIns.vue?vue&type=style&index=0&id=a584f170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a584f170",
  null
  
)

export default component.exports